import React from 'react';
import PropTypes from 'prop-types';

import Avatar from '../Avatar';

const propTypes = {

	/**
	 * The user to display.
	 */
	user: PropTypes.shape({

		/**
		 * The user display name.
		 */
		display_name: PropTypes.string.isRequired,

		/**
		 * An array of avatars (profile pictures).
		 */
		avatars: PropTypes.arrayOf(PropTypes.shape({

			image: PropTypes.string,

			signature: PropTypes.string,

			policy: PropTypes.string,

		})).isRequired,

	}).isRequired,

	/**
	 * The size of the avatar to render.
	 */
	size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

	/**
	 * Whether to round the avatar image.
	 */
	rounded: PropTypes.bool,

	/**
	 * The url to redirect to on click.
	 */
	url: PropTypes.string,

	/**
	 * Flag indicating whether this user should
	 * be displayed as a speaker.
	 */
	speaker: PropTypes.bool,

	/**
	 * Classes to pass down to the avatar
	 */
	className: PropTypes.string,

	/**
	 * Callback to handle additional logic for viewing the user profile modal.
	 */
	onClick: PropTypes.func,

};

const UserAvatar = ({ user, size, rounded, speaker, url, className, onClick }) => {

	if (!user) {
		return null;
	}

	const image = user.avatars && user.avatars.find((avatar) => avatar.active);

	// Keep track of the image URL for the user's avatar
	let imageURL;

	// Check if the user is has an active profile picture
	if (image) {

		imageURL = image.image;

		if (image.policy) {
			imageURL += `?policy=${image.policy}`;
		}

		if (image.signature) {
			imageURL += `&signature=${image.signature}`;
		}

	}

	return (
		<Avatar
			image={imageURL}
			title={user.display_name}
			size={size}
			speaker={speaker}
			rounded={rounded}
			url={url}
			className={className}
			onClick={onClick} />
	);

};

UserAvatar.propTypes = propTypes;

export default UserAvatar;
